// Medição real de pixel (canvas), não estimativa por caractere -- usada por qualquer coluna que
// precise de largura ajustada ao texto de verdade (admin-detail-chart-container.jsx,
// helpers/columnWidth.js). Local a este helper, não ao helper de relatório
// (helpers/report.js:getColumnWidth), pra não mudar a largura das 7 telas de resultado de
// relatório que usam aquele heurístico.
let measureContext;
// jsdom (suíte de teste) não implementa canvas 2D -- getContext('2d') volta null. Sem isso o
// teste quebra ao montar a tela (TypeError ao setar .font em null). Fallback por contagem de
// caractere só entra nesse caso; no browser real a medição de pixel de verdade sempre roda.
export const AVERAGE_CHAR_WIDTH_FALLBACK_PX = 8;

// As tabelas recalculam a largura das colunas sobre a lista inteira a cada render do container, e
// os valores quase não mudam entre renders. Medido no Chromium: 5000 linhas × 12 colunas custam
// cerca de 700 ms de measureText; com o resultado guardado por (fonte, texto) o render seguinte só
// consulta o Map. O limite evita crescer sem fim com textos que nunca se repetem (posições,
// horários); ao estourar, recomeça do zero.
export const MEASURE_CACHE_LIMIT = 50000;
const measureCache = new Map();

export const measureTextWidth = (text, font) => {
  if (measureContext === undefined) {
    measureContext = document.createElement('canvas').getContext('2d');
  }
  if (!measureContext) {
    return text.length * AVERAGE_CHAR_WIDTH_FALLBACK_PX;
  }
  const key = `${font}|${text}`;
  const cached = measureCache.get(key);
  if (cached !== undefined) return cached;
  measureContext.font = font;
  const width = measureContext.measureText(text).width;
  if (measureCache.size >= MEASURE_CACHE_LIMIT) measureCache.clear();
  measureCache.set(key, width);
  return width;
};
